<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div v-if="isDemo()" class="commingSoon">
        <div class="commingSoonMessage">
          Coming Soon
        </div>
      </div>
      <div v-else id="main">
        <section class="artworkTop">
          <div class="artworkTopTitle">
            <div class="inner4">
              <h1>作品展示</h1>
              <p class="titleSub">Exhibition</p>
            </div><!-- /inner4-->
          </div><!-- /artworkTopTitle-->
          <div class="artworkTopBody">
            <div class="inner2">
              <div class="artworkTopBlock">
                <h2>
                  <router-link to="/t10s">
                    <img
                      class="spExhibitionLogo"
                      src="/img/artworkTop_logo10sen.png"
                      srcset="/img/artworkTop_logo10sen@2x.png 2x"
                      alt="10選"
                    />
                  </router-link>
                </h2>
                <p>9億人を超える人々が約2,300万作品の中から選んだ作品「10選2019」を中心に新作、自信作を追加。更に2012から2018年に選ばれた10選メンバーを加えた、10選8世代による合同展示。</p>
                <ul class="dummy">
                  <router-link to="/t10s/2019"><li>10選2020</li></router-link>
                  <router-link to="/t10s/2019"><li>10選2019</li></router-link>
                  <router-link to="/t10s/2018"><li>10選2018</li></router-link>
                  <router-link to="/t10s/2017"><li>10選2017</li></router-link>
                  <router-link to="/t10s/2016"><li>10選2016</li></router-link>
                  <router-link to="/t10s/2015"><li>10選2015</li></router-link>
                  <router-link to="/t10s/2014"><li>10選2014</li></router-link>
                  <router-link to="/t10s/2013"><li>10選2013</li></router-link>
                  <router-link to="/t10s/2012"><li>10選2012</li></router-link>
                </ul>
              </div><!-- /artworkTopBlock-->

              <div class="artworkTopBlock">
                <h2>
                  <router-link to="/j100v">
                    <img
                      class="spExhibitionLogo"
                      src="/img/artworkTop_logo100kei.png"
                      srcset="/img/artworkTop_logo100kei@2x.png 2x"
                      alt="日本写真100景"
                    />
                  </router-link>
                </h2>
                <p>新型コロナウイルス感染症の影響により甚大な被害を受けた日本全国の名勝地、観光業の支援も視野に入れたフォトコンテスト「日本写真100景」の入選作品。</p>
                <ul class="dummy">
                  <router-link
                    v-for="area of areas" :key="area.id"
                    :to="`/artworks/Japan100Views/${area.id}`"
                  >
                    <li>{{area.name}}エリア</li>
                  </router-link>
                </ul>
              </div><!-- /artworkTopBlock-->

              <div class="artworkTopBlock last">
                <h2>
                  <router-link to="/artworks/MyPrecious">
                    <img
                      class="spExhibitionLogo"
                      src="/img/artworkTop_logoMypre.png"
                      srcset="/img/artworkTop_logoMypre@2x.png 2x"
                      alt="My Precious Photo Contest"
                    />
                  </router-link>
                </h2>
                <p>みなさんの日常にある「大切な存在」を、「大切である」という思いとともにおさめた一枚がテーマのフォトコンテスト「"My Precious" Photo Contest」の入選作品。</p>
                <ul class="flexNon">
                  <router-link to="/artworks/MyPrecious/200004"><li>「大切なあの人」部門</li></router-link>
                  <router-link to="/artworks/MyPrecious/200003"><li>「愛しい生きもの」部門</li></router-link>
                </ul>
              </div><!-- /artworkTopBlock-->
            </div><!-- /inner2-->
          </div><!-- /artworkTopBody-->

          <div class="artworkTopBottom">
            <div class="inner2">
              <router-link class="StandardBtn" to="/exhibitors">作品展示 展示者一覧</router-link>
            </div><!-- /inner2-->
          </div><!-- /artworkTopBottom-->
        </section><!-- /artworkTop-->
      </div><!-- /main-->
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    getArtworksCode (winner) {
      if (!this.awardTypeCode || !winner) return
      return this.awardTypeCode[winner.awardType]
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    }
  },
  created () {},
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.commingSoon {
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.commingSoonMessage {
  margin-top: -24px;
  text-align: center;
  font-size: 3rem;
  width: 600px;
}
</style>
